// import utils
import { enableStaticRendering } from "mobx-react-lite";
// Enable static rendering only on the server side
enableStaticRendering(typeof window === "undefined");
